import React from "react";
import ReactModal from "react-modal";
import Icon from "~/components/icons/icon";
import classNames from "classnames";

export interface IModalProps {
    className?: string;
    isOpen: boolean;
    noContainerMarkup?: boolean;
    onRequestClose?: () => void;
}

if (typeof window !== "undefined") {
    ReactModal.setAppElement("body");
}

const Modal: React.FC<IModalProps> = ({ className, noContainerMarkup, children, ...props }) => {
    const baseClass = "modal";
    const rootClasses = classNames(baseClass, className);

    const onClose = () => {
        if (props.onRequestClose) {
            props.onRequestClose();
        }
    };

    return (
        <ReactModal {...props} className={rootClasses} overlayClassName="modal-overlay">
            {noContainerMarkup ? (
                children
            ) : (
                <div className="modal-content">
                    <button type="button" className="modal-close-button" onClick={onClose}>
                        <Icon iconId="icon_28_close" />
                    </button>
                    <div className="modal__content__inner">{children}</div>
                </div>
            )}
        </ReactModal>
    );
};

export default Modal;
